<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <label class="mini-check"><input :id="`item-1-${item.id}`" type="checkbox" v-model="item.config.verify_with_sms"> پیامک</label>
      <label class="mini-check"><input :id="`item-2-${item.id}`" type="checkbox" v-model="item.config.digital_sign_handwrite"> دست‌نویس</label>
      <label class="mini-check"><input :id="`item-3-${item.id}`" type="checkbox" v-model="item.config.digital_sign_image"> عکس امضا</label>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "DigitalSignInput",
  props: {item: {}},
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>
.item-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.item-head .form-control {
  flex: 0 0 200px;
}
.mini-check {
  font-size: 12px;
  margin: 0;
  white-space: nowrap;
}
</style>
